<template>
  <div>
    <Send v-if="modalIsVisible" @trigger-modal="modalIsVisible = !modalIsVisible"/>
    <Headshot />
    <Name />
    <Address />
    <Buttons @trigger-modal="modalIsVisible = !modalIsVisible" />
    <Social />
  </div>
</template>

<script>
  import Send from './send.vue';
  import Headshot from './views/headshot.vue';
  import Name from './views/name.vue';
  import Address from './views/address.vue';
  import Buttons from './views/buttons.vue';
  import Social from './views/social.vue';
  
  export default {
    name: 'Home',
    props: {
      msg: String
    },
    data: () => {
      return {
        modalIsVisible: false
      }
    },
    components: {
      Send,
      Headshot,
      Name,
      Address,
      Buttons,
      Social
    },
  }
</script>

<style scoped>
</style>
